<script setup lang="ts">
import { nextTick, ref } from 'vue';
import { locale } from '../../locale';
import { Instance, createPopper } from '@popperjs/core';
import useHover from '../../composables/useHover';
const tooltip = ref<HTMLElement | null>(null);
const btn = ref<HTMLElement | null>(null);
const state = ref(false);
let popper: Instance | null = null;
const reset = () => {
  popper?.destroy();
  state.value = false;
};
const uh = useHover(btn, (hov) => {
  if (hov) {
    setTimeout(() => {
      if (uh.state.value) {
        showMessage()
      }
    }, 1000);
  } else {
    hideMessage()
  }
});
function showMessage() {
  if (!state.value) {
    state.value = true;
    nextTick(() => {
      popper = createPopper(
        btn.value as HTMLElement,
        tooltip.value as HTMLElement,
        {
          placement: "bottom",
          strategy: "fixed",
          modifiers: [{ name: "offset", options: { offset: [0, 5] } }],
        },
      );
    });
  }
}
function hideMessage() {
    popper?.destroy();
    state.value = false;
}
defineExpose({
  reset
})
</script>
<template>
  <div class="wrapper">
  <svg ref="btn" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3V14.3333M10 14.3333L14.2498 10.2409M10 14.3333L5.75024 10.2409M4 17H16" stroke="#747474"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
    <div v-if="state" class="tooltip" ref="tooltip">
      {{ locale.downloadRecord }}
    </div>
  </div>
</template>
<style scoped>
svg {
  flex-shrink: 0;
  cursor: pointer;
}
.wrapper {
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}
.tooltip {
  max-width: 450px;
  overflow-wrap: break-word;
  background-color: rgba(41, 41, 41, 0.85);
  color: #ececec;
  border-radius: 7px;
  padding: 8px 15px;
}
</style>
